<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :showSearchForm="false"
               :showPage="false"
               tableApi="admin/xiaoyun/withdrawList"
    >
     <!-- <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="daterange" placement="bottom-end" placeholder="提现日期" style="width: 200px"></DatePicker>
        </FormItem>
      </template>-->

      <!--<template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>-->
    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  export default {
    name: "driver",
    components:{pageTable},
    data() {
      return {
        showEdit:false,
        editUserId:0,     //编辑的用户ID
        searchData: {
          mobile: '',
          create_time:''
        },
        tableColumn: [
          {title: 'ID',key: 'id',align: "center"},
          {title: '用户ID',key: 'userId',align: "center"},
          {title: '手机号',key: 'mobile',align: "center"},
          {title: '提现升数',key: 'litreNum',align: "center"},
          {title: '提现单价',key: 'price',align: "center"},
          {title: '提现金额(元)',key: 'total',align: "center"},
          {title: '收款二维码',align: "center",render:(h,params)=>{
              let content = [];
              if (params.row.qrCodeImg !== ''){
                content.push(h('img',{
                  attrs:{src:params.row.qrCodeImg},
                  style:{width:'60px',height:'60px'},
                  // on:{click:()=>{this.showProof(params.row)}}
                }))
              }
              return h('div',content)
            }},
          {title: '提现时间',key: 'createTime',align: "center"},
          {title:'操作',render:(h,params)=>{
            if (params.row.status===1){
              return h('div','已付款')
            }else{
              return h('Button',
                {props:{type:'primary',size:'small'},
                  on:{click:()=>{this.doWithdraw(params.row)}}},
                '确认付款'
              )
            }

            }}
        ],
        tableData: [],
      }
    },
    methods: {
      async doWithdraw(info){
        info.remark = ''
        this.$Modal.confirm({
          title:'确认付款',
          render:(h)=>{
            return h( 'Input', {
              size: "large",
              modelValue: info.remark,
              autofocus: true,
              placeholder: '请输入备注',
              on:{
                input:(val)=>{info.remark=val}
              }
            })
          },
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/xiaoyun/doWithDraw',info)
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg)
              this.$Modal.remove()
              this.$refs.table.getLists();
            })
          }
        })

      }
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
